import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { ArrowDown, Phone, Mail, MapPin, Calendar } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function BeginTheConversation() {
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll();
  const {
    ref: contactRef,
    isVisible: contactVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="begin-the-conversation" className="dark bg-background text-foreground py-24 md:py-32 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full max-w-7xl pointer-events-none opacity-5">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--color-primary)_0%,_transparent_70%)] blur-3xl" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div ref={textRef} className={`flex flex-col items-center text-center max-w-4xl mx-auto transition-all duration-1000 ease-out ${textVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-serif text-4xl md:text-6xl lg:text-7xl text-white mb-6 tracking-tight leading-tight">
            The Conversation Begins Privately.
          </h2>
          
          <p className="text-muted-foreground text-lg md:text-xl max-w-2xl mx-auto mb-12 font-light leading-relaxed">
            Your financial legacy requires discretion. We invite you to initiate a confidential dialogue with our managing partners to discuss your wealth architecture and tax strategies.
          </p>

          <div className="flex flex-col items-center gap-4 mb-16">
            <span className="text-sm uppercase tracking-widest text-primary/80 font-medium">
              Contact Details Below
            </span>
            <ArrowDown className="w-8 h-8 text-primary animate-bounce" />
          </div>
        </div>

        <div ref={contactRef} className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12 max-w-6xl mx-auto transition-all duration-1000 delay-300 ease-out ${contactVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {}
          <div className="flex flex-col items-center text-center group">
            <div className="w-16 h-16 rounded-full bg-secondary/10 flex items-center justify-center mb-6 group-hover:bg-secondary/20 transition-colors duration-300">
              <Phone className="w-6 h-6 text-primary" />
            </div>
            <h3 className="text-xl font-serif text-white mb-3">Direct Line</h3>
            <p className="text-muted-foreground mb-4">
              Speak directly with our advisory team.
            </p>
            <Button variant="link" asChild className="text-white hover:text-primary p-0 h-auto text-lg">
              <Link to="tel:7045551234">(704) 555-1234</Link>
            </Button>
          </div>

          {}
          <div className="flex flex-col items-center text-center group">
            <div className="w-16 h-16 rounded-full bg-secondary/10 flex items-center justify-center mb-6 group-hover:bg-secondary/20 transition-colors duration-300">
              <Mail className="w-6 h-6 text-primary" />
            </div>
            <h3 className="text-xl font-serif text-white mb-3">Secure Email</h3>
            <p className="text-muted-foreground mb-4">
              Request a private consultation via email.
            </p>
            <Button variant="link" asChild className="text-white hover:text-primary p-0 h-auto text-lg">
              <Link to="mailto:contact@cyradonc.com">contact@cyradonc.com</Link>
            </Button>
          </div>

          {}
          <div className="flex flex-col items-center text-center group">
            <div className="w-16 h-16 rounded-full bg-secondary/10 flex items-center justify-center mb-6 group-hover:bg-secondary/20 transition-colors duration-300">
              <MapPin className="w-6 h-6 text-primary" />
            </div>
            <h3 className="text-xl font-serif text-white mb-3">Office</h3>
            <p className="text-muted-foreground mb-4">Serving clients across the Carolinas</p>
            <span className="text-white text-lg">4539 Hedgemore Drive
<br />Suite 103
<br />Charlotte, NC 28209

</span>
          </div>

          {}
          <div className="flex flex-col items-center text-center group">
            <div className="w-16 h-16 rounded-full bg-secondary/10 flex items-center justify-center mb-6 group-hover:bg-secondary/20 transition-colors duration-300">
              <SafeHydrate><Calendar className="w-6 h-6 text-primary" /></SafeHydrate>
            </div>
            <h3 className="text-xl font-serif text-white mb-3">Schedule a Call</h3>
            <p className="text-muted-foreground mb-4">
              Book a time that works best for your schedule.
            </p>
            <Button variant="link" asChild className="text-white hover:text-primary p-0 h-auto text-lg">
              <Link to="https://calendly.com/cyradon-capital">View Calendar</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}